<form class="flex flex-col gap-4" [formGroup]="form">
  <mat-slide-toggle formControlName="isDefault">
    <div class="flex items-center gap-2">
      <span>Set as Default Billing Entity</span>
      <mat-icon
        matTooltip="This will be defaulted to over the other billing entities when creating invoices."
      >
        info
      </mat-icon>
    </div>
  </mat-slide-toggle>

  <div class="flex flex-col gap-4">
    <mat-form-field class="flex-1" subscriptSizing="dynamic">
      <mat-label>Label</mat-label>
      <input matInput formControlName="displayName" />
      <mat-hint> This label will be shown on the invoice.</mat-hint>
    </mat-form-field>

    <div class="flex flex-col gap-4" formGroupName="entity">
      <div class="flex gap-4">
        <mat-form-field class="flex-1" subscriptSizing="dynamic">
          <mat-label>Entity Registration Type</mat-label>
          <mat-select formControlName="registrationNumberType">
            @for (entityType of entityTypes$ | async; track entityType) {
              <mat-option [value]="entityType">
                {{ entityType }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field class="flex-1" subscriptSizing="dynamic">
          <mat-label>Entity Registration Number</mat-label>
          <input matInput formControlName="registrationNumber" />
        </mat-form-field>
      </div>

      <mat-form-field class="flex-1" subscriptSizing="dynamic">
        <mat-label>Address</mat-label>
        <textarea matInput formControlName="address"></textarea>
        <mat-hint> This address will be shown on invoices. </mat-hint>
      </mat-form-field>

      <div
        class="flex justify-end"
        matTextSuffix
        (click)="$event.stopImmediatePropagation()"
      >
        <ng-content />
      </div>
    </div>
  </div>
</form>
